'use es6';

import promiseClient from '../adapters/promiseClient';
import noAuthWithCredentialsHubapi from '../stacks/noAuthWithCredentialsHubapi';

export default promiseClient(noAuthWithCredentialsHubapi);
